import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from 'http-client/hooks/authHooks';
import { useCurrentUserQuery } from 'http-client/hooks/authHooks';

const ProfileMenu: React.FC = () => {
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  const { mutate: logout, isPending: isLoggingOut } = useLogoutMutation();
  const { data: user, isLoading } = useCurrentUserQuery();
  let username = 'User';

  if (user?.data) {
    const { name, email, phoneNumber, role } = user.data;
    username = name || email || phoneNumber || role || 'User';
  }

  const handleLogout = () => {
    logout(undefined, {
      onSuccess: () => {
        navigate('/login');
      },
    });
  };

  return (
    <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
      <DropdownToggle className="btn header-item" id="page-header-user-dropdown" tag="button">
        <span
          className="rounded-circle header-profile-user bg-primary text-white d-inline-flex align-items-center justify-content-center"
          style={{ width: '32px', height: '32px' }}
        >
          {username.charAt(0).toUpperCase()}
        </span>
        <span className="d-none d-md-inline-block ms-2 me-1">
          {isLoading ? 'Loading...' : username}
        </span>
        <i className="mdi mdi-chevron-down d-none d-md-inline-block" />
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem tag="a" href="/profile">
          <i className="bx bx-user font-size-15 align-middle me-1" />
          Profile
        </DropdownItem>
        <div className="dropdown-divider" />
        <a className="dropdown-item" href="#" onClick={handleLogout}>
          <i className="bx bx-power-off font-size-15 align-middle me-1 text-danger" />
          <span>{isLoggingOut ? 'Logging Out...' : 'Sign Out'}</span>
        </a>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileMenu;
